import { useNavigate } from "react-router-dom";
import { LuUsers, LuStore } from "react-icons/lu";

import ListPageHeader from "../list-page/ListPageHeader";

export default function WinnerOptions() {
  const navigate = useNavigate();

  const options = [
    {
      key: "individuals",
      name: "Qytetarë",
      description: "Qytetarët fitues nga lojërat me kupona.",
      icon: LuUsers,
      link: "/winners/individuals",
    },
    {
      key: "businesses",
      name: "Biznese",
      description: "Bizneset fituese nga lojërat e biznesit.",
      icon: LuStore,
      link: "/winners/businesses",
    },
  ];

  return (
    <div className="min-h-full h-full bg-gradient-to-b from-gray-50/60 via-white to-white flex flex-col">
      <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8">
        <ListPageHeader
          eyebrow={{ icon: <LuUsers size={18} />, label: "Fituesit" }}
          title="Zgjidh kategorinë e fituesve"
          subtitle="Shiko fituesit individualë ose bizneset fituese."
        />
      </div>

      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        <div className="w-full max-w-3xl grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {options.map((option) => {
            const Icon = option.icon;
            return (
              <button
                key={option.key}
                type="button"
                onClick={() => navigate(option.link)}
                className="group flex flex-col items-center justify-center text-center gap-4 rounded-2xl border border-gray-200 bg-white p-6 sm:p-8 min-h-[260px] transition-all duration-200 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:border-[var(--secondary-color)] focus:outline-none focus:ring-2 focus:ring-[var(--secondary-color)]/40"
              >
                <span className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-50 group-hover:bg-[var(--secondary-color)]/10 transition-colors">
                  <Icon
                    className="text-gray-500 group-hover:text-[var(--secondary-color)] transition-colors"
                    size={56}
                  />
                </span>
                <span className="text-lg sm:text-xl font-semibold text-gray-700 group-hover:text-[var(--secondary-color)] transition-colors">
                  {option.name}
                </span>
                <span className="text-xs sm:text-sm text-gray-500 max-w-[18rem]">
                  {option.description}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
